import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Entity } from 'src/app/core/models/entity.model';
import { MultilevelItem } from 'src/app/core/models/multilevel-selector.model';
import { User } from 'src/app/core/models/user.model';
import { ConfigService } from 'src/app/core/services/config.service';
import * as utils from 'src/app/shared/helpers/utils';


@Component({
  selector: 'hbo-single-select-multi-level',
  templateUrl: './single-select-multi-level.component.html',
  styleUrls: ['./single-select-multi-level.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SingleSelectMultiLevelComponent),
      multi: true
    }
  ]
})
export class SingleSelectMultiLevelComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input('selection') selection!: Entity | null;
  @Input('userEntity') userEntity!: User | null;
  value!: Entity;
  private touched = false;
  disabled!: boolean;
  selected!: Entity | null;

  multilevelSelectorHead: string = 'DATATABLE.FILTERS.ENTITY';
  multilevelSelectorHeadNumber!: number;
  clearSelectorPB!: boolean;
  maxLevel!: number;
  minLevel!: number;
  selectorSearch!: string;
  allSelected!: boolean;
  @Input("tree") tree!: Entity[] | undefined | null;
  @Input("max") max!: number | undefined;
  @Input("search") search!: string | undefined;
  @Input("typeData") typeData!: String;
  @Output('callback') callback = new EventEmitter;
  @ViewChild('selector') selector!: ElementRef;
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: { target: any; }): void {
    if (!this.selector.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }

  @Input("data") data: MultilevelItem[] = [];


  showDropdown!: boolean;

  user: User = utils?.localStorageGetItem('user');

  constructor(private configSvc: ConfigService) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
  }

  iterateItemUnselect(_item: MultilevelItem) {
    _item.selected = false;
    _item.childs?.map((item: MultilevelItem) => this.iterateItemUnselect(item))
  }
  iterateItemVisible(_item: MultilevelItem) {
    _item.visible = true;
    _item.childs?.map((item: MultilevelItem) => this.iterateItemVisible(item))
  }
  iterateEveryUncheck(_level: MultilevelItem[], _selected: MultilevelItem) {
    if (_selected.target) {
      _level.map((item: MultilevelItem) => {
        item.target.id != _selected.target.id
          ? (
            item.selected = false,
            this.iterateEveryUncheck(item.childs!, _selected)
          )
          : this.iterateEveryUncheck(item.childs!, _selected);
      })
    }
  }

  ngOnInit(): void {
    this.search
      ? this.selectorSearch = this.search
      : null;

    this.allSelected
      ? this.data.map((item: MultilevelItem) => this.iterateItemUnselect(item))
      : null;
    switch (this.typeData) {
      case 'policy':
        this.selected = this.selection;
        break;
      case 'device':
        this.selected = this.selection;
        break;
      case 'user':
        this.selected = this.selection;
        break;
      case 'team':
        this.selected = this.selection;
        break;
      default:
        this.selected = this.tree?.find((item: Entity) => item.id == this.selection?.parentEntityId)!;
        break;
    }
    switch (this.typeData) {
      case 'newDevice':
        break;
      case 'newUser':
        break;
      case 'newTeam':
        break;
      case 'newPackage':
        break;
      default:
        this.setmultilevelSelectorHead(1);
        break;
    }

    console.log(this.tree);

  }

  //https://stackblitz.com/edit/stackblitz-starters-xymizt?file=src%2Fcustom-input%2Fcustom-input.component.ts
  valueChanged(val: number | string | null) {
    this.onChange(val);
    this.markAsTouched();
  }
  onChange = (value: number | string | null) => { };

  onTouched: any = () => { };

  ngOnChanges(changes: SimpleChanges): void {
    switch (this.typeData) {
      case 'policy':
        console.log(this.tree);
        this.data = [];
        this.max = 3;
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = 1;
        this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
        break;
      case 'newDevice':
        this.data = [];
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = 2;
        this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevelChilds(this.user.entity) })
        if (this.max === 1 || this.data[0].target.entityTypeId === this.max) {
          this.data[0].selected = true;
          this.selected = this.data[0].target;
          this.selection = this.data[0].target;
          this.valueChanged(1);
          this.callback.emit('change');
        } else {
          this.selected = null;
          this.selection = { id: 0 } as Entity;
          this.valueChanged('');
        }
        break;
      case 'newPackage':
        this.data = [];
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = 2;
        this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevelChilds(this.user.entity) })
        if (this.max === 1 || this.data[0].target.entityTypeId === this.max) {
          /*this.data[0].selected = true;
          this.selected = this.data[0].target;
          this.selection = this.data[0].target;*/
          this.valueChanged(1);
          this.callback.emit('change');
        } else {
          this.selected = null;
          this.selection = { id: 0 } as Entity;
          this.valueChanged('');
        }
        break;

      case 'newEntity':
        this.data = [];
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = Math.min(...this.tree!.map(o => o.entityTypeId));
        this.tree!
          .filter((item: Entity) => item.entityTypeId == this.minLevel)
          .map((item: Entity) => {
            this.data.push({ visible: true, opened: true, all: false, selected: false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
          })
        if (this.data.length == 1 && !this.data[0].childs!.length) {
          this.data[0].selected = true;
          this.selected = this.data[0].target;
          this.selection!.parentEntityId = this.data[0].target.id;
          this.valueChanged(this.selection!.parentEntityId);
          this.callback.emit('change');
        } else {
          this.selected = null;
          this.selection = { id: 0 } as Entity;
          this.valueChanged('');
        }

        break;
      case 'located':
        this.data = [];
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = Math.min(...this.tree!.map(o => o.entityTypeId));
        this.tree!
          .filter((item: Entity) => item.entityTypeId == this.minLevel)
          .map((item: Entity) => {
            this.data.push({ visible: true, opened: true, all: false, selected: false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
          })
        if (this.data.length == 1 && !this.data[0].childs!.length) {
          this.data[0].selected = true;
          this.selected = this.data[0].target;
          this.selection!.parentEntityId = this.data[0].target.id;
          this.valueChanged(this.selection!.parentEntityId);
          this.callback.emit('change');
        } else {
          /*this.selected = null;
          this.selection = { id: 0 } as Entity;
          this.valueChanged('');*/
          this.data[0].childs![0].selected = true;
          this.selected = this.data[0].childs![0].target;
          this.selection!.parentEntityId = this.data[0].childs![0].target.id;
          this.valueChanged(this.selection!.parentEntityId);
          this.callback.emit('change');
        }

        break;
      case 'newUser':
        this.data = [];
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = 2;
        this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevelChilds(this.user.entity) })
        if (this.max === 1 || this.data[0].target.entityTypeId === this.max) {
          this.data[0].selected = true;
          this.selected = this.data[0].target;
          this.selection = this.data[0].target;
          this.valueChanged(1);
          this.callback.emit('change');
        } else {
          this.selected = null;
          this.selection = { id: 0 } as Entity;
          this.valueChanged('');
        }

        break;
      case 'newTeam':
        console.log(this.tree);
        this.data = [];
        this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
        this.minLevel = 2;
        this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
        if (this.max === 1 || this.data[0].target.entityTypeId === this.max) {
          console.log(this.data[0].target.entityTypeId)
          if (this.data[0].target.entityTypeId != 1) {
            this.data[0].selected = true;
            this.selected = this.data[0].target;
            this.selection = this.data[0].target;
            this.valueChanged(this.data[0].target.id);
            this.callback.emit('change');
          }

        } else {
          this.selected = null;
          this.selection = { id: 0 } as Entity;
          this.valueChanged('');
        }
        console.log(this.data);
        break;
      default:
        switch (this.typeData) {
          case 'device':
            this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
            this.minLevel = 2;
            this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevelChilds(this.user.entity) })
            break;
          case 'user':
            this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
            this.minLevel = 2;
            this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevelChilds(this.user.entity) })
            break;
          case 'team':
            this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
            this.minLevel = 2;
            this.data.push({ visible: true, opened: true, all: true, selected: this.selection?.id == this.user.entityId ? true : false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
            break;
          default:
            this.max ? this.maxLevel = this.max - 1 : this.maxLevel = Math.max(...this.tree!.map(o => o.entityTypeId));
            this.tree ? this.minLevel = Math.min(...this.tree!.map(o => o.entityTypeId)) : null;
            switch (this.typeData) {
              case 'reassignPackage':
                if (this.tree) this.tree!
                  .filter((item: Entity) => item.entityTypeId == this.minLevel)
                  .map((item: Entity) => {
                    this.data.push({ visible: true, opened: true, all: false, selected: item.id == this.selection?.parentEntityId ? true : false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
                  })
                break;
              default:
                if (this.tree) this.tree!
                  .filter((item: Entity) => item.entityTypeId == this.minLevel)
                  .map((item: Entity) => {
                    this.data.push({ visible: true, opened: true, all: false, selected: item.id == this.selection?.parentEntityId ? true : false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
                  })
                break;
            }
            break;
        }


        break;
    }
    this.setmultilevelSelectorHead(2)

  }

  writeValue(value: Entity): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private markAsTouched(): void {
    if (!this.touched) {
      this.touched = true;
      this.onTouched();
    }
  }
  setLevel(_item: Entity) {
    if (_item.entityTypeId < this.maxLevel) {
      let levelChilds: MultilevelItem[] = [];
      this.tree!
        .filter((item: Entity) => item.parentEntityId == _item.id)
        .map((child: Entity) => {
          let selectedStatus: boolean = false
          switch (this.typeData) {
            case 'policy':
              selectedStatus = child.id == this.selection?.id ? true : false;
              break;
            default:
              selectedStatus = child.id == this.selection?.parentEntityId ? true : false;
              break;
          }
          levelChilds.push({ visible: true, opened: true, all: false, selected: selectedStatus, level: child.entityTypeId, type: child.entityTypeId, target: child, childs: this.setLevel(child) });
        });
      return levelChilds
    } else {
      return [];
    }

  }
  setLevelChilds(_item: Entity) {
    let levelChilds: MultilevelItem[] = [];
    this.user.childEntities!
      .filter((item: Entity) => item.parentEntityId == _item.id)
      .map((child: Entity) => {
        levelChilds.push({ visible: true, opened: false, all: true, selected: child.id == this.selection?.id ? true : false, level: child.entityTypeId, type: child.entityTypeId, target: child, childs: this.setLevelChilds(child) });
      });
    return levelChilds
  }
  toogleDropdown() {
    this.showDropdown = !this.showDropdown;
  }
  toogle(_item: MultilevelItem) {
    _item.opened = !_item.opened;
  }
  change(e: any, _item: MultilevelItem): void {
    this.showDropdown = false;
    this.selected = _item.target;
    this.setmultilevelSelectorHead();
    switch (this.typeData) {
      case 'newTeam':
        console.log(_item);
        console.log(this.selection);
        break;
      case 'policy':
        console.log(_item);
        console.log(this.selection);
        break
      default:
        this.selection!.parentEntityId = _item.target.id;
        break;
    }

    this.valueChanged(_item.target.id);
    this.iterateEveryUncheck(this.data, _item);
  }
  iterateItem(_item: MultilevelItem, _shops_selected: Entity[]) {
    if (_item.target.entityTypeId != 4) {
      _item.childs!.map((item: MultilevelItem) => {
        this.iterateItem(item, _shops_selected)
      })
    } else {
      _item.selected ? _shops_selected.push(_item.target) : null;
    }
  }

  setEntity(e: any) {
    this.showDropdown = false;
    this.selected = e.target;
    this.setmultilevelSelectorHead();
    switch (this.typeData) {
      case 'newTeam':
        if (this.selection) this.selection!.parentEntityId = e.target.id;
        break;
      case 'policy':
        if (this.selection) this.selection!.parentEntityId = e.target.id;
        break;
      case 'newPackage':
        if (this.selection) this.selection!.parentEntityId = e.target.id;
        break;
      default:
        this.selection!.parentEntityId = e.target.id;
        break;
    }

    this.valueChanged(e.target.id);
    this.iterateEveryUncheck(this.data, e);
    switch (this.typeData) {
      case 'reassignPackage':
        this.clearSelectorPB = true;
        break;
      default:
        break;
    }
  }

  visibleEntity(e: { item: MultilevelItem, value: boolean }) {
    e.item.visible = e.value;
  }

  iterateItems() {
    let shops_selected: Entity[] = [];
    this.data.map((item: MultilevelItem) => {
      this.iterateItem(item, shops_selected)
    })
    shops_selected.length == this.tree!.filter((item: Entity) => item.entityTypeId == 4)!.length
      || !shops_selected.length
      ? this.multilevelSelectorHead = 'DATATABLE.FILTERS.ENTITY'
      : shops_selected.length > 1
        ? this.multilevelSelectorHead = 'DATATABLE.FILTERS.MANYENTITIES'
        : shops_selected.length == 1
          ? this.multilevelSelectorHead = shops_selected[0].name
          : this.multilevelSelectorHead = 'DATATABLE.FILTERS.ENTITY';

    (!shops_selected || !shops_selected.length)
      || shops_selected && shops_selected.length == this.tree!.filter((item: Entity) => item.entityTypeId == 4)!.length
      ? this.allSelected = true
      : this.allSelected = false;
  }
  setmultilevelSelectorHead(_number?: number) {
    if (this.selected) {
      console.log(this.selected.name);
      this.multilevelSelectorHeadNumber = 1;
      this.multilevelSelectorHead = this.selected.name;
    } else {
      this.multilevelSelectorHeadNumber = 0;
      this.multilevelSelectorHead = 'DATATABLE.FILTERS.ENTITY';
      switch (this.typeData) {
        case 'located':
          if (this.user.roleId == 1) this.multilevelSelectorHead = this.user.entity.name;
          break;
        default:
          this.multilevelSelectorHead = 'DATATABLE.FILTERS.ENTITY';
          break;
      }

    }
  }

  clear(e: any) {
    switch (this.typeData) {
      case 'reassignPackage':
        this.showDropdown = false;
        this.allSelected = true;
        this.clearSelectorPB = false;
        this.search = '';
        this.data.map((item: MultilevelItem) => this.iterateItemUnselect(item));
        this.selected = null;
        this.setmultilevelSelectorHead();
        this.valueChanged(null);
        break;
      default:
        this.allSelected = true;
        this.clearSelectorPB = false;
        this.search = '';
        this.data = [];
        this.tree!
          .filter((item: Entity) => item.entityTypeId == this.minLevel)
          .map((item: Entity) => {
            this.data.push({ visible: true, opened: true, all: false, selected: item.id == this.selection?.parentEntityId ? true : false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
          });
        this.callback.emit('change');
        break;
    }
  }

  onChangeSearch(e: Event, _type?: string) {
    switch (_type) {
      case 'search':

        break;
      default:
        break;
    }
  }
  applyFilters() {

  }
}
